import { useContext } from 'react';

import { I18nContext } from '../contexts/i18n-context';

import type { TranslationService } from '@web-platform/shared-travel-tools-types/src/translation-service';

export const useTranslations = (): TranslationService => {
  const i18nCtx = useContext(I18nContext);
  if (!i18nCtx) throw new Error('useTranslations must be used within I18nContext.Provider');
  const { translate, translatePlural } = i18nCtx;
  return { translate, translatePlural };
};
